export const PROJECT_CODE = process.env.REACT_APP_PROJECT_CODE;
export const API_GATEWAY = process.env.REACT_APP_API_GATEWAY;
export const IG_REPORT = process.env.REACT_APP_IG_REPORT;
export const CDN_PROJECT_NAME = process.env.REACT_APP_CDN_PROJECT_NAME;
export const IG_SENDER = process.env.REACT_APP_IG_SENDER;

export const BASE_URL = "/";

export const PR_DEP = "evn-service";
export const MS_SENDER = "sender-service";

export const TIMEZONE = "Europe/Istanbul";

export const AZURE_ACTIVE_DOMAIN = {
  appId: process.env.REACT_APP_AZURE_APP_ID,
  redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
  scopes: [
    "user.read",
    "user.ReadBasic.all",
    "Calendars.ReadWrite",
    "Calendars.ReadWrite.Shared",
  ],
  tenant: "6cf18ffb-42c6-4d7d-9874-5c515ab0c6ae",
};

export const AZURE_ROOMS_EMAIL = [
  {
    roomsEmail: "DTASMaltepeZumrutevler@denv.onmicrosoft.com",
    roomsDisplayName: "Maltepe Zümrütevler",
  },
  {
    roomsEmail: "DTASMaltepeGulsuyu@denv.onmicrosoft.com",
    roomsDisplayName: "Maltepe Gülsuyu",
  },
  { roomsEmail: "DTASHendek@denv.onmicrosoft.com", roomsDisplayName: "Hendek" },
];
